<template>
  <v-overlay opacity=".8">
    <v-sheet class="pa-5 text-center">
      <v-row>
        <v-col cols="12">
          Esta função só pode ser acessada no modo ONLINE
        </v-col>
        <v-col>
          <v-btn color="info" @click="$router.go(-1)" rounded>OK</v-btn>
        </v-col>
      </v-row>
    </v-sheet>
  </v-overlay>
</template>

<script>
export default {};
</script>

<style>
</style>